import { render, staticRenderFns } from "./RolePlayground.vue?vue&type=template&id=0b0fb47c"
import script from "./RolePlayground.vue?vue&type=script&lang=js"
export * from "./RolePlayground.vue?vue&type=script&lang=js"
import style0 from "./RolePlayground.vue?vue&type=style&index=0&id=0b0fb47c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports